import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './checkbox.scss'

let checkboxIdCount = 0

class Checkbox extends Component {

	constructor() {
		super()
		this.keyPress = this.keyPress.bind(this)
	}

	keyPress(e) {
		if (e.charCode === 32) {
			this.props.onChange(!this.props.value)
		}
	}

	componentDidMount() {
		if (!this.props.id) {
			checkboxIdCount += 1
		}
	}

	render() {
		const checkboxId = this.props.id || 'checkbox_' + checkboxIdCount

		return (
			<label
				tabIndex={0}
				htmlFor={checkboxId}
				onBlur={this.props.onBlur}
				onFocus={this.props.onFocus}
				onKeyPress={this.keyPress}
				styleName={
					classNames({
						block: true,
						'block--error': this.props.status === 'error',
						'block--active': this.props.active&&this.props.activeStyle,
					})
				}
			>
				<input
					onChange={this.props.onChange}
					styleName="checkbox_hidden"
					type='checkbox'
					id={checkboxId}
					value={this.props.value}
					checked={this.props.value} />
				<span styleName="checkbox_span"></span>
			</label>
		)
	}

}

Checkbox.defaultProps = {
	activeStyle: true,
}

Checkbox.propTypes = {
	status: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
}

export default CSSModules(Checkbox, styles, {allowMultiple: true})
